import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { HomepageCardContentItem } from 'components/HomepageCard/HomepageCardContentItem';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';
import { Separator } from 'components/Separator/Separator';

import { TENANT_ID } from 'global/constants';

import { getLexikonUrl } from 'utils/UrlUtil';
import { getTenantId, withTenant } from 'utils/tenantUtil';

import './HomepageCard.sass';

export const HomepageCard = ({ classNames, data, loading, disabled, isLexikon }) => {
  const tenantId = getTenantId();

  const getSeparatorColor = () => {
    if (tenantId === TENANT_ID.AVA) {
      return 'homepage';
    }
    if (tenantId === TENANT_ID.BAG) {
      return 'secondary';
    }
    return 'white';
  };

  const renderCardContent = () =>
    data.teaser.elementsList.map((element, index) => (
      <HomepageCardContentItem key={index} name={element.name} number={element.number} />
    ));

  const card = (
    <div
      data-testid={withTenant('homepageCard')}
      className={`mdl-card homepage-card-container ${classNames}`}>
      <div className="homepage-card-title-container">
        <div>{data.title}</div>
        <div className="homepage-card-icon-container">
          <div className={`${tenantId}`}>{data.icon}</div>
          {data?.secondIcon && <div className={`${tenantId}`}>{data.secondIcon}</div>}
        </div>
      </div>
      <Separator color={getSeparatorColor()} />
      <div className={`homepage-card-content-container ${tenantId}`}>
        {loading ? (
          <LoadingIndicator className="card-component-loading-indicator" />
        ) : (
          renderCardContent()
        )}
      </div>
    </div>
  );

  if (disabled) {
    return card;
  }

  if (isLexikon) {
    return <a href={getLexikonUrl()}>{card}</a>;
  }

  return <Link to={data.actionLink.linkedPage}>{card}</Link>;
};

HomepageCard.propTypes = {
  data: PropTypes.object,
  classNames: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  isLexikon: PropTypes.bool,
};

HomepageCard.defaultProps = {
  data: {},
  classNames: '',
  loading: false,
  disabled: false,
  isLexikon: false,
};
